import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../LandingPages/Navbar/Navbar';
import Footer from '../LandingPages/Footer/Footer';
import AIChatbotButton from './AIChatbot/AIChatbotButton';

const Layout = ({ children }) => {
    const location = useLocation();
    const hideNavbarAndFooter = location.pathname === '/preview-bookings';
    return (
        <>

            {!hideNavbarAndFooter && <Navbar />}
            <main>{children}</main>
            {!hideNavbarAndFooter && <Footer/>}
            <AIChatbotButton />
        </>
    );
};

export default Layout;
